import { classNames, React } from '@digsup/core-ui';
import { styles } from './ErrorCard.scss';

const cx = classNames.bind(styles);

export const ErrorCard = () => {
  const classes = cx('c-error-card');

  return (
    <>
      <head>
        <title>OOPS - Error on DigsUp</title>
      </head>
      <div className={classes}>
        <div className="c-error-card__box">
          <div className="c-error-card__content">
            <h1 className="c-error-card__title">OOPS!</h1>
            <p className="c-error-card__text">
              Sometimes life comes at you faster than you were prepared for.
              Don&apos;t worry; we&apos;re working on it. Back ASAP.
            </p>
            <p className="c-error-card__footer">XOXO</p>
          </div>
        </div>
      </div>
    </>
  );
};
